import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customQueueCalendarRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-custom-calendar',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
	exact: true,
};
